module.exports = __webpack_public_path__ + "img/Infobox.54fa353b.png";